import {BrickContext, ActionBrick, registerBrick, ErrorFlow} from 'olympe';

export default class CopyToClipboard extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} text
     * @param {boolean} html
     * @param {function()} forwardEvent
     */
    async update($, [text, html], [forwardEvent]) {
        try {

            if (html) {
                const blobInput = new Blob([text], {type: 'text/html'});
                const clipboardItemInput = new ClipboardItem({'text/html' : blobInput});
                await navigator.clipboard.write([clipboardItemInput]);
            } else {
                // Safest implementation but can't feed new lines
                // const parser = new DOMParser();
                // const doc = parser.parseFromString(text, 'text/html');
                // const textContent = doc.body.textContent || "";

                //  Replace tags by new lines
                const textContent = text.replace(/(<([^>]+)>)/gi, "\n").replaceAll('\n\n', '\n');
                await navigator.clipboard.writeText(textContent.trim());
            }
            forwardEvent();
        } catch (err) {
            throw ErrorFlow.create(`Failed to copy: ${err.message}`, 500);
        }
    }
}

registerBrick('01915bb63f16d9c97154', CopyToClipboard);
